import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import DashboardLayout from './components/Layout/DashboardLayout';
import MFA from './components/Auth/MFA';
import AdminLogin from './pages/admin/AdminLogin';
import AdminMFA from './pages/admin/AdminMFA';
import AdminResetPassword from './pages/admin/AdminResetPassword';
import ResetMFAToken from './pages/admin/ResetMFAToken';
import TestResetMFA from './pages/admin/TestResetMFA';
import SecureQRCode from './pages/admin/SecureQRCode';
import TestSecureQR from './pages/admin/TestSecureQR';
import Welcome from './pages/Welcome';
import Premium from './pages/Premium';
import Exposure from './pages/Exposure';
import Claims from './pages/Claims';
import AdminPartner from './pages/admin/AdminPartner';
import AdminPartnerCreate from './pages/admin/AdminPartnerCreate';
import AdminReference from './pages/admin/AdminReference';
import AdminReferenceSubcoveragesUpdateImport from './pages/admin/AdminReferenceSubcoveragesUpdateImport';
import AdminReferenceSubcoveragesImport from './pages/admin/AdminReferenceSubcoveragesImport';
import AdminEmail from './pages/admin/AdminEmail';
import AdminSms from './pages/admin/AdminSms';
import AdminSmsCreate from './pages/admin/AdminSmsCreate';
import AdminMailingList from './pages/admin/AdminMailingList';
import AdminManagement from './pages/admin/AdminManagement';
import AdminUsers from './pages/admin/AdminUsers';
import AdminUserDetail from './pages/admin/AdminUserDetail';
import AdminUserCreate from './pages/admin/AdminUserCreate';
import AdminUserEdit from './pages/admin/AdminUserEdit';
import AdminClient from './pages/admin/AdminClient';
import AdminClientPhoneImport from './pages/admin/AdminClientPhoneImport';
import AdminClaims from './pages/admin/AdminClaims';
import AdminPolicies from './pages/admin/AdminPolicies';
import AdminForecasts from './pages/admin/AdminForecasts';
import AdminActivities from './pages/admin/AdminActivities';
import AdminActivityCreate from './pages/admin/AdminActivityCreate';
import AdminActivityDetail from './pages/admin/AdminActivityDetail';
import AdminActivitiesQuotes from './pages/admin/AdminActivitiesQuotes';
import AdminActivityQuoteDetail from './pages/admin/AdminActivityQuoteDetail';
import AdminTrips from './pages/admin/AdminTrips';
import AdminTripsPolicies from './pages/admin/AdminTripsPolicies';
import AdminTripsClaims from './pages/admin/AdminTripsClaims';
import AdminTripsClaimsManagement from './pages/admin/AdminTripsClaimsManagement';
import AdminTripsCheckClaims from './pages/admin/AdminTripsCheckClaims';
import AdminTripsCheckClaimDetail from './pages/admin/AdminTripsCheckClaimDetail';
import AdminTripsForecasts from './pages/admin/AdminTripsForecasts';
import AdminTripForecastDetail from './pages/admin/AdminTripForecastDetail';
import AdminTripsForecastsNotTriggered from './pages/admin/AdminTripsForecastsNotTriggered';
import AdminTripsForecastBackupCheck from './pages/admin/AdminTripsForecastBackupCheck';
import AdminTripsObservationBackupCheck from './pages/admin/AdminTripsObservationBackupCheck';
import AdminActivityForecasts from './pages/admin/AdminActivityForecasts';
import AdminActivityForecastDetail from './pages/admin/AdminActivityForecastDetail';
import AdminActivityForecastsNotTriggered from './pages/admin/AdminActivityForecastsNotTriggered';
import AdminActivityForecastNotTriggeredDetail from './pages/admin/AdminActivityForecastNotTriggeredDetail';
import AdminActivityManualForecastCheck, { AdminGreenRiverManualForecastCheck } from './pages/admin/AdminActivityManualForecastCheck';
import AdminForecastNotTriggeredDetail from './pages/admin/AdminForecastNotTriggeredDetail';
import AdminTripsSubcoverages from './pages/admin/AdminTripsSubcoverages';
import AdminTripsObservations from './pages/admin/AdminTripsObservations';
import AdminTripObservationDetail from './pages/admin/AdminTripObservationDetail';
import AdminActivityObservations from './pages/admin/AdminActivityObservations';
import AdminActivityObservationDetail from './pages/admin/AdminActivityObservationDetail';
import AdminTripSubcoverageDetail from './pages/admin/AdminTripSubcoverageDetail';
import AdminTripSubcoverageEdit from './pages/admin/AdminTripSubcoverageEdit';
import AdminTripClaimDetail from './pages/admin/AdminTripClaimDetail';
import AdminTripDetail from './pages/admin/AdminTripDetail';
import AdminTripEdit from './pages/admin/AdminTripEdit';
import AdminTripPolicyDetail from './pages/admin/AdminTripPolicyDetail';
import AdminCommercialGestures from './pages/admin/AdminCommercialGestures';
import AdminCommercialGestureCreate from './pages/admin/AdminCommercialGestureCreate';
import AdminCommercialGestureDetail from './pages/admin/AdminCommercialGestureDetail';
import AdminCommercialGestureEdit from './pages/admin/AdminCommercialGestureEdit';
import AdminCommercialGestureBulkTransfers from './pages/admin/AdminCommercialGestureBulkTransfers';
import AdminCommercialGestureBulkPayments from './pages/admin/AdminCommercialGestureBulkPayments';
import AdminActivityPolicyDetail from './pages/admin/AdminActivityPolicyDetail';
import AdminPartnerDetail from './pages/admin/AdminPartnerDetail';
import AdminPartnerEdit from './pages/admin/AdminPartnerEdit';
import AdminReferenceDetail from './pages/admin/AdminReferenceDetail';
import AdminClientDetail from './pages/admin/AdminClientDetail';
import AdminClientEdit from './pages/admin/AdminClientEdit';
import AdminEmailDetail from './pages/admin/AdminEmailDetail';
import AdminEmailEdit from './pages/admin/AdminEmailEdit';
import AdminEmailCreate from './pages/admin/AdminEmailCreate';
import AdminSmsDetail from './pages/admin/AdminSmsDetail';
import AdminSmsEdit from './pages/admin/AdminSmsEdit';
import AdminActivitySubcoverages from './pages/admin/AdminActivitySubcoverages';
import AdminActivitySubcoverageCreate from './pages/admin/AdminActivitySubcoverageCreate';
import AdminActivitySubcoverageDetail from './pages/admin/AdminActivitySubcoverageDetail';
import AdminActivityClaimDetail from './pages/admin/AdminActivityClaimDetail';
import AdminCheckClaims from './pages/admin/AdminCheckClaims';
import AdminCheckClaimDetail from './pages/admin/AdminCheckClaimDetail';
import AdminTripsBulkTransfers from './pages/admin/AdminTripsBulkTransfers';
import AdminTripsRibForm from './pages/admin/AdminTripsRibForm';
import AdminTripsPoliciesImport from './pages/admin/AdminTripsPoliciesImport';
import AdminTripsPoliciesCancelledImport from './pages/admin/AdminTripsPoliciesCancelledImport';
import AdminTripsPoliciesModifiedImport from './pages/admin/AdminTripsPoliciesModifiedImport';
import AdminTripsPoliciesExport from './pages/admin/AdminTripsPoliciesExport';
import AdminTripsCheckClaimsExport from './pages/admin/AdminTripsCheckClaimsExport';
import AdminTripsCheckClaimWeatherDetails from './pages/admin/AdminTripsCheckClaimWeatherDetails';
import AdminActivityPoliciesImport from './pages/admin/AdminActivityPoliciesImport';
import AdminActivityPoliciesExport from './pages/admin/AdminActivityPoliciesExport';
import AdminActivityClaimsExport from './pages/admin/AdminActivityClaimsExport';
import AdminTripsDaily from './pages/admin/AdminTripsDaily';
import AdminWeatherDailyAnalysis from './pages/admin/AdminWeatherDailyAnalysis';
import TripClientPolicies from './pages/admin/TripClientPolicies';
import OperationsDashboard from './pages/dashboard/operations/OperationsDashboard';
import ForecastDashboard from './pages/dashboard/operations/ForecastDashboard';
import ObservationDashboard from './pages/dashboard/operations/ObservationDashboard';
import EndOfStayDashboard from './pages/dashboard/operations/EndOfStayDashboard';
import './App.css';

// Pages Trip (à créer)
const TripDaily = () => <div className="dashboard-page"><h2>Trip - Notifications clients</h2></div>;
const TripExposureClaims = () => <div className="dashboard-page"><h2>Trip - Exposure & Claims</h2></div>;
const TripPolicies = () => <div className="dashboard-page"><h2>Trip - Gestion Polices</h2></div>;

// Pages Activity (à créer)
const ActivityDaily = () => <div className="dashboard-page"><h2>Activity - Notifications clients</h2></div>;
const ActivityPolicies = () => <div className="dashboard-page"><h2>Activity - Gestion Polices</h2></div>;

// Composant pour protéger les routes
const PrivateRoute = ({ children }) => {
    const adminAuthState = useSelector(state => state.adminAuth);
    const isAuthenticated = adminAuthState.isAuthenticated && !adminAuthState.mfaRequired;

    return isAuthenticated ? children : <Navigate to="/admin/login" />;
};

function App() {
    const { isAuthenticated, mfaRequired } = useSelector(state => state.adminAuth);

    useEffect(() => {
        // Rediriger vers welcome si authentifié et sur login admin
        if (isAuthenticated && !mfaRequired && window.location.pathname === '/admin/login') {
            window.location.href = '/dashboard/operations';
        }
    }, [isAuthenticated, mfaRequired]);

    return (
        <Router>
            <Routes>
                <Route path="/login" element={<Navigate to="/admin/login" replace />} />
                <Route path="/mfa" element={<MFA />} />

                {/* Admin Authentication Routes */}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin/reset-password" element={<AdminResetPassword />} />
                <Route path="/admin/mfa" element={<AdminMFA />} />
                <Route path="/admin/reset-mfa-token" element={<ResetMFAToken />} />
                <Route path="/admin/test-reset-mfa" element={<TestResetMFA />} />
                <Route path="/admin/mfa/secure-qr" element={<SecureQRCode />} />
                <Route path="/admin/test-secure-qr" element={<TestSecureQR />} />

                <Route
                    path="/"
                    element={
                        <PrivateRoute>
                            <DashboardLayout />
                        </PrivateRoute>
                    }
                >
                    <Route index element={<Navigate to="/welcome" />} />
                    <Route path="welcome" element={<Welcome />} />
                    <Route path="dashboard/operations" element={<OperationsDashboard />} />
                    <Route path="dashboard/operations/forecast" element={<ForecastDashboard />} />
                    <Route path="dashboard/operations/observation" element={<ObservationDashboard />} />
                    <Route path="dashboard/operations/end-of-stay" element={<EndOfStayDashboard />} />
                    <Route path="premium" element={<Premium />} />
                    <Route path="exposure" element={<Exposure />} />
                    <Route path="claims" element={<Claims />} />

                    {/* Admin Routes */}
                    <Route path="admin/partner" element={<AdminPartner />} />
                    <Route path="admin/partner/create" element={<AdminPartnerCreate />} />
                    <Route path="admin/partner/:partnerId" element={<AdminPartnerDetail />} />
                    <Route path="admin/partner/edit/:partnerId" element={<AdminPartnerEdit />} />
                    <Route path="admin/reference" element={<AdminReference />} />
                    <Route path="admin/reference/subcoverages/import" element={<AdminReferenceSubcoveragesImport />} />
                    <Route path="admin/reference/subcoverages/update-import" element={<AdminReferenceSubcoveragesUpdateImport />} />
                    <Route path="admin/reference/:referenceId" element={<AdminReferenceDetail />} />
                    <Route path="admin/email" element={<AdminEmail />} />
                    <Route path="admin/email/create" element={<AdminEmailCreate />} />
                    <Route path="admin/email/edit/:emailManagementId" element={<AdminEmailEdit />} />
                    <Route path="admin/email/:emailManagementId" element={<AdminEmailDetail />} />
                    <Route path="admin/sms" element={<AdminSms />} />
                    <Route path="admin/sms/create" element={<AdminSmsCreate />} />
                    <Route path="admin/sms/edit/:smsManagementId" element={<AdminSmsEdit />} />
                    <Route path="admin/sms/:smsManagementId" element={<AdminSmsDetail />} />
                    <Route path="admin/mailing-list" element={<AdminMailingList />} />
                    <Route path="admin/management" element={<AdminManagement />} />
                    <Route path="admin/users/create" element={<AdminUserCreate />} />
                    <Route path="admin/users/edit/:userId" element={<AdminUserEdit />} />
                    <Route path="admin/users/:userId" element={<AdminUserDetail />} />
                    <Route path="admin/client" element={<AdminClient />} />
                    <Route path="admin/client/import-phone" element={<AdminClientPhoneImport />} />
                    <Route path="admin/client/edit/:clientId" element={<AdminClientEdit />} />
                    <Route path="admin/client/:clientId" element={<AdminClientDetail />} />
                    <Route path="admin/claims" element={<AdminClaims />} />
                    <Route path="activity/claims" element={<AdminClaims />} />
                    <Route path="activity/claims/export" element={<AdminActivityClaimsExport />} />
                    <Route path="activity/claims/:claimId" element={<AdminActivityClaimDetail />} />
                    <Route path="activity/observations" element={<AdminActivityObservations />} />
                    <Route path="activity/observations/:observationId" element={<AdminActivityObservationDetail />} />
                    <Route path="activity/check-claims" element={<AdminCheckClaims />} />
                    <Route path="activity/check-claims/:checkClaimId" element={<AdminCheckClaimDetail />} />
                    <Route path="activity/policies" element={<AdminPolicies />} />
                    <Route path="activity/policies/export" element={<AdminActivityPoliciesExport />} />
                    <Route path="activity/policies/import" element={<AdminActivityPoliciesImport />} />
                    <Route path="activity/policies/:policyId" element={<AdminActivityPolicyDetail />} />
                    <Route path="activity/activities" element={<AdminActivities />} />
                    <Route path="activity/activities/create" element={<AdminActivityCreate />} />
                    <Route path="activity/activities/:activityId" element={<AdminActivityDetail />} />
                    <Route path="activity/quotes" element={<AdminActivitiesQuotes />} />
                    <Route path="activity/quotes/:quoteId" element={<AdminActivityQuoteDetail />} />
                    <Route path="activity/forecasts" element={<AdminActivityForecasts />} />
                    <Route path="activity/forecasts/manual-check" element={<AdminActivityManualForecastCheck />} />
                    <Route path="activity/forecasts/manual-check/green-river" element={<AdminGreenRiverManualForecastCheck />} />
                    <Route path="activity/forecasts/:forecastId" element={<AdminActivityForecastDetail />} />
                    <Route path="activity/forecasts-not-triggered" element={<AdminActivityForecastsNotTriggered />} />
                    <Route path="activity/forecasts-not-triggered/:forecastNotTriggeredId" element={<AdminActivityForecastNotTriggeredDetail />} />
                    <Route path="admin/forecasts" element={<AdminForecasts />} />
                    <Route path="admin/trips" element={<AdminTrips />} />
                    <Route path="admin/trips/commercial-gestures" element={<AdminCommercialGestures />} />
                    <Route path="admin/trips/commercial-gestures/new" element={<AdminCommercialGestureCreate />} />
                    <Route path="admin/trips/commercial-gestures/bulk-transfers" element={<AdminCommercialGestureBulkTransfers />} />
                    <Route path="admin/trips/commercial-gestures/bulk-payments" element={<AdminCommercialGestureBulkPayments />} />
                    <Route path="admin/trips/commercial-gestures/:gestureId/edit" element={<AdminCommercialGestureEdit />} />
                    <Route path="admin/trips/commercial-gestures/:gestureId" element={<AdminCommercialGestureDetail />} />
                    <Route path="admin/trips/:tripId" element={<AdminTripDetail />} />
                    <Route path="admin/trips/edit/:tripId" element={<AdminTripEdit />} />
                    <Route path="admin/trips/policies" element={<AdminTripsPolicies />} />
                    <Route path="admin/trips/policies/export" element={<AdminTripsPoliciesExport />} />
                    <Route path="admin/trips/policies/import" element={<AdminTripsPoliciesImport />} />
                    <Route path="admin/trips/policies/cancelled-import" element={<AdminTripsPoliciesCancelledImport />} />
                    <Route path="admin/trips/policies/modified-import" element={<AdminTripsPoliciesModifiedImport />} />
                    <Route path="admin/trips/policies/:policyId" element={<AdminTripPolicyDetail />} />
                    <Route path="admin/trips/claims" element={<AdminTripsClaims />} />
                    <Route path="admin/trips/claims/:claimId" element={<AdminTripClaimDetail />} />
                    <Route path="admin/trips/claims-management" element={<AdminTripsClaimsManagement />} />
                    <Route path="admin/trips/check-claims" element={<AdminTripsCheckClaims />} />
                    <Route path="admin/trips/check-claims/export" element={<AdminTripsCheckClaimsExport />} />
                    <Route path="admin/trips/check-claims/weather-details" element={<AdminTripsCheckClaimWeatherDetails />} />
                    <Route path="admin/trips/check-claims/:checkClaimId" element={<AdminTripsCheckClaimDetail />} />
                    <Route path="admin/trips/forecasts" element={<AdminTripsForecasts />} />
                    <Route path="admin/trips/forecasts/:forecastId" element={<AdminTripForecastDetail />} />
                    <Route path="admin/trips/observations" element={<AdminTripsObservations />} />
                    <Route path="admin/trips/observations/:observationId" element={<AdminTripObservationDetail />} />
                    <Route path="admin/trips/subcoverages" element={<AdminTripsSubcoverages />} />
                    <Route path="admin/trips/subcoverages/:subcoverageTripId" element={<AdminTripSubcoverageDetail />} />
                    <Route path="admin/trips/subcoverages/:subcoverageTripId/edit" element={<AdminTripSubcoverageEdit />} />
                    <Route path="admin/trips/forecasts-not-triggered" element={<AdminTripsForecastsNotTriggered />} />
                    <Route path="admin/trips/forecast-backup-check" element={<AdminTripsForecastBackupCheck />} />
                    <Route path="admin/trips/observation-backup-check" element={<AdminTripsObservationBackupCheck />} />
                    <Route path="admin/trips/forecasts-not-triggered/:forecastNotTriggeredId" element={<AdminForecastNotTriggeredDetail />} />
                    <Route path="admin/trips/bulk-transfers" element={<AdminTripsBulkTransfers />} />
                    <Route path="admin/trips/rib-form" element={<AdminTripsRibForm />} />
                    <Route path="admin/trips/daily" element={<AdminTripsDaily />} />
                    <Route path="admin/weather-daily-analysis" element={<AdminWeatherDailyAnalysis />} />
                    <Route
                        path="admin/weather-daily-analysis/forecasts/standard/check-forecast"
                        element={<Navigate to="/admin/weather-daily-analysis" replace />}
                    />
                    <Route path="activity/subcoverages" element={<AdminActivitySubcoverages />} />
                    <Route path="activity/subcoverages/create" element={<AdminActivitySubcoverageCreate />} />
                    <Route path="activity/subcoverages/:subcoverageId" element={<AdminActivitySubcoverageDetail />} />

                    {/* Trip Routes */}
                    <Route path="trip/daily" element={<TripDaily />} />
                    <Route path="trip/exposure-claims" element={<TripExposureClaims />} />
                    <Route path="trip/client-policies" element={<TripClientPolicies />} />

                    {/* Activity Routes */}
                    <Route path="activity/daily" element={<ActivityDaily />} />
                </Route>
            </Routes>
        </Router>
    );
}

export default App;
